module.exports = __webpack_public_path__ + "img/scrm2img17.f3cba398.png";